export default "__VITE_ASSET__BGOhYmNA__"